export default __webpack_public_path__ + "static/media/automatskavrata8.ac4689b2.jpg";